import React from 'react'
import { connect } from 'react-redux'
import withStyles from 'material-ui-next/styles/withStyles'
import WorldsAndCategoriesDropdowns from './WorldsAndCategoriesDropdowns'
import { getTopBarConfig } from '../../selectors'
import { get } from 'lodash'

const styles = theme => ({
  title: {
    alignSelf: 'center',
  },
})

const makeLinkTo = ({ world, category }) => {
  if (category) {
    return `/category/${category.slug}`
  }
  if (world) {
    return `/world/${world.slug}`
  }
  return '/all-worlds'
}

const MainToolbarTitleMobile = ({
  classes,
  title,
  worldSlug,
  categorySlug,
  titleDropdownWorlds,
}) => {
  if (titleDropdownWorlds) {
    if (worldSlug) {
      return (
        <div className={classes.title}>
          <WorldsAndCategoriesDropdowns
            white
            biggerFontOnMobile
            showAllWorlds={true}
            hideCategories={true}
            makeLinkTo={makeLinkTo}
            worldSlug={worldSlug}
          />
        </div>
      )
    } else if (categorySlug) {
      return (
        <div className={classes.title}>
          <WorldsAndCategoriesDropdowns
            white
            biggerFontOnMobile
            showAllWorlds={true}
            hideCategories={true}
            makeLinkTo={makeLinkTo}
            categorySlug={categorySlug}
          />
        </div>
      )
    } else {
      return (
        <div className={classes.title}>
          <WorldsAndCategoriesDropdowns
            white
            biggerFontOnMobile
            showAllWorlds={true}
            hideCategories={true}
            makeLinkTo={makeLinkTo}
          />
        </div>
      )
    }
  } else {
    return <div className={classes.title}>{title ? title : ''}</div>
  }
}

const mapStateToProps = state => {
  const { title, match, titleDropdownWorlds } = getTopBarConfig(state)

  // TODO: This sucks bitch find a bettere solution
  let worldSlug
  let categorySlug
  if (titleDropdownWorlds) {
    worldSlug = get(match, 'params.world')
    categorySlug = get(match, 'params.category')
  }

  return {
    titleDropdownWorlds,
    title,
    worldSlug,
    categorySlug,
  }
}

export default withStyles(styles)(
  connect(mapStateToProps)(MainToolbarTitleMobile)
)



// WEBPACK FOOTER //
// ./src/common/TopBar/MainToolbarTitleMobile.js